export default "__VITE_ASSET__sxVR2ylM__"